import { HtmlBlockWithStyles } from 'component/HtmlBlock';
import { AcknowledgementForSingleCve } from 'types';

/**
 * Renders a list of acknowledgement texts for a CVE.
 *
 * Returns a dash if no acknowledgement texts are available.
 */
export const AckTextList = ({
  cveAck,
}: {
  cveAck: AcknowledgementForSingleCve | undefined;
}) => {
  if (!cveAck || !cveAck.ackText || cveAck.ackText.length === 0) {
    return <>-</>;
  }
  return (
    <ul style={{ listStyle: 'none', paddingInlineStart: 0 }}>
      {cveAck.ackText?.map((ackText, index) => (
        <li key={`ack-${index}-${ackText}`}>
          <HtmlBlockWithStyles>{ackText}</HtmlBlockWithStyles>
        </li>
      ))}
    </ul>
  );
};
